import { delay } from "lodash";

// use a script tag or an external JS file

document.addEventListener("DOMContentLoaded", (event) => {
    gsap.registerPlugin(ScrollTrigger)
    // gsap code here!
    let tl = gsap.timeline()

    //header
    tl.from(".site-header-group > .container", {
        opacity: 0,
        duration: 1,
        y: -150,
        stagger: 0.2,
    })

    tl.from(".site-branding, .main-navigation ul li , .header-chat-wrap ul li, .header-btn-wrap ul li, .header-widget-area .wp-block-group > *", {
        opacity: 0,
        duration: 1,
        y: -50,
        stagger: 0.08,
        delay: 1,
    })


    //slider

    gsap.from(".featured-slider", {
        opacity: 0,
        duration: 1,
        y: -150,
    })

    gsap.from(".tour-search-wrap ul", {
        opacity: 0,
        duration: 1,
        y: 70,
        stagger: 0.2,
        delay: 1,
    })

    gsap.from(".tour-search-wrap ul li", {
        opacity: 0,
        duration: 1,
        y: -20,
        stagger: 0.5,
        delay: 2,
    })

    // recommended tour section
    gsap.from(".recommended-tour-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".recommended-tour-section",
            scroller: "body",
            start: "top 80%",
            end: "top 65%",
            scrub: 3,
        }
    })

    gsap.from(".recommended-tour-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".recommended-tour-section",
            scroller: "body",
            start: "top 80%",
            end: "top 55%",
            scrub: 3,
        }
    })
    gsap.from(".recommended-tour-section .post-wrapper .post", {
        y: "250",
        opacity: 0,
        stagger: 0.4,
        scrollTrigger: {
            trigger: ".recommended-tour-section",
            scroller: "body",
            start: "top 60%",
            end: "top 15%",
            scrub: 3,
        }
    })
    gsap.from(".recommended-tour-section .btn-wrapper", {
        y: "250",
        opacity: 0,
        scrollTrigger: {
            trigger: ".recommended-tour-section",
            scroller: "body",
            start: "top 20%",
            end: "top -5%",
            scrub: 3,
        }
    })

    // home aboutus section
    gsap.from(".home-aboutus-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".home-aboutus-section",
            scroller: "body",
            start: "top 80%",
            end: "top 65%",
            scrub: 3,
        }
    })

    gsap.from(".home-aboutus-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".home-aboutus-section",
            scroller: "body",
            start: "top 80%",
            end: "top 55%",
            scrub: 3,
        }
    })
    gsap.from(".home-aboutus-image-wrap .featured-image:first-child", {
        transform: "translateY(-150px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".home-aboutus-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })
    gsap.from(".home-aboutus-image-wrap .featured-image:last-child", {
        transform: "translateY(150px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".home-aboutus-section",
            scroller: "body",
            start: "top 35%",
            end: "top 15%",
            scrub: 3,
        }
    })

    gsap.from(".home-aboutus-content-wrapper .entry-content", {
        y: "50",
        opacity: 0,
        scrollTrigger: {
            trigger: ".home-aboutus-section",
            scroller: "body",
            start: "top 60%",
            end: "top 40%",
            scrub: 3,
        }
    })
    gsap.from(".home-aboutus-experiance ul li", {
        y: "50",
        opacity: 0,
        stagger: 0.3,
        scrollTrigger: {
            trigger: ".home-aboutus-section",
            scroller: "body",
            start: "top 40%",
            end: "top 15%",
            scrub: 3,
        }
    })
    gsap.from(".home-aboutus-section .btn-wrapper", {
        y: "250",
        opacity: 0,
        scrollTrigger: {
            trigger: ".home-aboutus-section",
            scroller: "body",
            start: "top 20%",
            end: "top 10%",
            scrub: 3,
        }
    })

    // top categories section
    gsap.from(".top-categories-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".top-categories-section",
            scroller: "body",
            start: "top 70%",
            end: "top 55%",
            scrub: 3,
        }
    })

    gsap.from(".top-categories-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".top-categories-section",
            scroller: "body",
            start: "top 70%",
            end: "top 55%",
            scrub: 3,
        }
    })

    gsap.from(".top-categories-section .top-categories-slide-item", {
        transform: "translateX(250px)",
        opacity: 0,
        stagger: 0.4,
        scrollTrigger: {
            trigger: ".top-categories-section",
            scroller: "body",
            start: "top 70%",
            end: "top 40%",
            scrub: 3,
        }
    })

    // why with us section
    gsap.from(".why-with-us-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".why-with-us-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })

    gsap.from(".why-with-us-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".why-with-us-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })
    gsap.from(".why-with-us-content-wrapper .why-with-us-content-item", {
        transform: "translateY(400px)",
        opacity: 0,
        stagger: 0.4,
        scrollTrigger: {
            trigger: ".why-with-us-section",
            scroller: "body",
            start: "top 50%",
            end: "top 15%",
            scrub: 3,
        }
    })
    gsap.from(".why-with-us-wrapper .why-with-us-image-wrapper", {
        transform: "translateY(400px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".why-with-us-section",
            scroller: "body",
            start: "top 55%",
            end: "top 25%",
            scrub: 5,
        }
    })

    // popular tours section
    gsap.from(".popular-tours-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".popular-tours-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })

    gsap.from(".popular-tours-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".popular-tours-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })
    gsap.from(".popular-tours-section .post-wrapper .post", {
        y: "250",
        opacity: 0,
        stagger: 0.3,
        scrollTrigger: {
            trigger: ".popular-tours-section",
            scroller: "body",
            start: "top 40%",
            end: "top -30%",
            scrub: 3,
        }
    })
    gsap.from(".popular-tours-section .post-wrapper + .btn-wrapper", {
        y: "250",
        opacity: 0,
        scrollTrigger: {
            trigger: ".popular-tours-section",
            scroller: "body",
            start: "top -20%",
            end: "top -50%",
            scrub: 3,
        }
    })

    // reviews section
    gsap.from(".reviews-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".reviews-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })

    gsap.from(".reviews-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".reviews-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })
    gsap.from(".reviews-section .reviews-image-item", {
        transform: "translateY(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".reviews-section",
            scroller: "body",
            start: "top 40%",
            end: "top 10%",
            scrub: 3,
        }
    })
    gsap.from(".reviews-section .reverse-reviews-image-item", {
        transform: "translateY(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".reviews-section",
            scroller: "body",
            start: "top 55%",
            end: "top 30%",
            scrub: 3,
        }
    })
    gsap.from(".reviews-section .reviews-slider-item ", {
        transform: "translateY(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".reviews-section",
            scroller: "body",
            start: "top 40%",
            end: "top 10%",
            scrub: 3,
        }
    })
    gsap.from(".reviews-section .btn-wrapper", {
        y: "250",
        opacity: 0,
        scrollTrigger: {
            trigger: ".reviews-section",
            scroller: "body",
            start: "top 10%",
            end: "top -10%",
            scrub: 3,
        }
    })

    // upcoming tours section
    gsap.from(".upcoming-tours-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".upcoming-tours-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })

    gsap.from(".upcoming-tours-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".upcoming-tours-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })
    gsap.from(".upcoming-tours-section .post-wrapper .post", {
        y: "250",
        opacity: 0,
        stagger: 0.3,
        scrollTrigger: {
            trigger: ".upcoming-tours-section",
            scroller: "body",
            start: "top 50%",
            end: "top 15%",
            scrub: 3,
        }
    })

    // promo section
    gsap.from(".promo-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".promo-section",
            scroller: "body",
            start: "top 40%",
            end: "top 15%",
            scrub: 3,
        }
    })
    gsap.from(".promo-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".promo-section",
            scroller: "body",
            start: "top 40%",
            end: "top 15%",
            scrub: 3,
        }
    })
    gsap.from(".promo-section .promo-content-wrap", {
        scale: 0,
        opacity: 0,
        scrollTrigger: {
            trigger: ".promo-section",
            scroller: "body",
            start: "top 70%",
            end: "top 35%",
            scrub: 3,
        }
    })
    gsap.from(".promo-section .promo-content-wrap .entry-content", {
        y: "250",
        opacity: 0,
        scrollTrigger: {
            trigger: ".promo-section",
            scroller: "body",
            start: "top 40%",
            end: "top 15%",
            scrub: 3,
        }
    })

    // blog section
    gsap.from(".blog-section .entry-header.heading .entry-subtitle", {
        transform: "translateX(-250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".blog-section",
            scroller: "body",
            start: "top 60%",
            end: "top 30%",
            scrub: 3,
        }
    })
    gsap.from(".blog-section .entry-header.heading .entry-title", {
        transform: "translateX(250px)",
        opacity: 0,
        scrollTrigger: {
            trigger: ".blog-section",
            scroller: "body",
            start: "top 60%",
            end: "top 30%",
            scrub: 3,
        }
    })
    gsap.from(".blog-section .post-wrapper .post", {
        y: "250",
        opacity: 0,
        stagger: 0.3,
        scrollTrigger: {
            trigger: ".blog-section",
            scroller: "body",
            start: "top 50%",
            end: "top 0%",
            scrub: 3,
        }
    })
    gsap.from(".blog-section .btn-wrapper", {
        y: "250",
        opacity: 0,
        scrollTrigger: {
            trigger: ".blog-section",
            scroller: "body",
            start: "top 0%",
            end: "top -20%",
            scrub: 3,
        }
    })

    // footer
    gsap.from(".footer-widget-area .widget-area", {
        y: "250",
        opacity: 0,
        stagger: 0.3,
        scrollTrigger: {
            trigger: ".site-footer",
            scroller: "body",
            start: "bottom 170%",
            end: "bottom 110%",
            scrub: 3,
        }
    })
    gsap.from(".site-footer .site-info", {
        opacity: 0,
        scrollTrigger: {
            trigger: ".site-footer",
            scroller: "body",
            start: "top 200%",
            end: "top 170%",
            scrub: 3,
        }
    })


});